import { useRef, useState } from "react";
import { Button, Card, CardBody, CardFooter } from "reactstrap";
import { VideoPlayBtn } from "../../assets/designedPickedIcons";
import { showInFullScreen } from "../specials/FullScreenView";
import { FaLocationDot } from "react-icons/fa6";

const CommercialSmCard = ({ details, animation }) => {
  const videoRef = useRef();
  const [isPlaying, setisPlaying] = useState(false);

  const handleClick = () => {
    setisPlaying((prev) => !prev);
    if (videoRef.current) {
      if (videoRef?.current?.paused) videoRef?.current?.play();
      else videoRef?.current?.pause();
    }
  };
  console.log("video mdetai os", details?.mediaUrl);

  return (
    <Card
      className="bg-white border-none outer-black-shadow full-height w-full"
      style={{ borderRadius: "15.11px", animation: animation }}
    >
      <div
        onClick={() => handleClick()}
        className="d-flex align-items-center justify-content-center "
      >
        <video
          onClick={(e) => {
            e?.stopPropagation();
            handleClick();
            showInFullScreen(e?.target, [], e?.target?.src);
          }}
          ref={videoRef}
          src={details?.mediaUrl}
          height={200}
          className=" object-fit-cover full-width "
          muted
          loop
          style={{ borderRadius: "10.66px" }}
          alt="commercial-video"
        />
        {!isPlaying && (
          <Button
            onClick={(e) => {
              e?.stopPropagation();
              handleClick();
            }}
            className="p-0 bg-transparent position-absolute border-none"
          >
            <VideoPlayBtn />
          </Button>
        )}
      </div>
      <CardBody className="px-2 py-3">
        <h5 className="f-5 mb-1">{details?.name}</h5>
        <small className="d-block mb-1">
          
          {details?.place?.location?.streetAddress??""}</small>
        <p className="color-half-black-4 mb-1 ">{details?.description}</p>
   
        <p className="color-half-black text-end m-0 font-bold bg-transparent border-none">
        ({details?.place?.name})
        </p>
      </CardBody>
     
    </Card>
  );
};

export default CommercialSmCard;
